
<script>
import request from "./request.vue";
import session from "./session.vue";

export default {


  sendContact: async function(data) {
    try {
      const resp =  await request.send('https://api.japanparts.com.br/api/contacts', data, false, 'post');
      resp.success = true;
      return resp;
    } catch (error) {
      const resp = {...error, succes:false}
      return resp
    }
	}
};
</script>



// WEBPACK FOOTER //
// src/api/contact.vue